var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 69,
    rx: 7.5,
    fill: "#0433EF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 69,
    rx: 7.5,
    stroke: "#0433EF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_168_899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.1668 28.6746V42.0833C49.1669 43.1674 48.7527 44.2105 48.009 44.9992C47.2653 45.7879 46.2483 46.2627 45.1662 46.3263L44.9168 46.3333H25.0835C23.9994 46.3334 22.9564 45.9192 22.1676 45.1755C21.3789 44.4318 20.9042 43.4149 20.8406 42.3327L20.8335 42.0833V28.6746L34.2139 37.5953L34.3782 37.6888C34.5719 37.7835 34.7846 37.8327 35.0002 37.8327C35.2157 37.8327 35.4284 37.7835 35.6221 37.6888L35.7864 37.5953L49.1668 28.6746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9168 23.6667C46.4468 23.6667 47.7884 24.4742 48.5364 25.6882L35.0001 34.7124L21.4639 25.6882C21.8191 25.1113 22.3071 24.6277 22.8872 24.2778C23.4673 23.9278 24.1227 23.7217 24.7987 23.6766L25.0835 23.6667H44.9168Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_168_899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(18 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailUs);
export default __webpack_public_path__ + "static/media/Mail Us.775aceb73b3db9564292f317e6b00c76.svg";
export { ForwardRef as ReactComponent };